import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ActivityCondition } from "../../../../../../models/activity-condition";
import { ActivityConditionType } from "../../../../../../models/activity-condition-type";
import { Law } from "../../../../../../models/laws";
import { Registration } from "../../../../../../models/registration";
import { RegistrationActivityCondition } from "../../../../../../models/registration-activity-condition";
import { ActivityConditionControllerService } from "../../../../../../services/activity-condition/activity-condition-controller.service";
import { ActivityConditionService } from "../../../../../../services/activity-condition/activity-condition.service";
import { RegistrationActivityConditionControllerService } from "../../../../../../services/activity-condition/registration-activity-condition-controller.service";
import { Store } from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "activity-condition-edit",
  templateUrl: "./activity-condition-edit.component.html",
  styles: [],
  providers: [ToastrService],
})
export class ActivityConditionEditComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  @Input() public serviceId: string;
  @Input() public activityCondition: ActivityCondition;
  @Input() public registrationActivityCondition: RegistrationActivityCondition;
  @Input() public registration: Registration;
  @Input() public laws: Law[] = [];
  @Input() public activityConditionTypes: ActivityConditionType[] = [];
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  @Input() public addNew: boolean = false;
  public showDeterminantBuilder: boolean = false;
  public subscription: any;
  public isLoading: boolean = false;

  constructor(private activityConditionControllerService: ActivityConditionControllerService,
              private registrationActivityConditionControllerService: RegistrationActivityConditionControllerService,
              public activityConditionService: ActivityConditionService,
              public store: Store,
              public toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.activityConditionService.editData.subscribe((data) => {
      this.serviceId = data.serviceId;
      this.registration = data.registration;
      this.activityCondition = data.activityCondition;
      this.registrationActivityCondition = data.registrationActivityCondition;
      this.laws = data.laws;
      this.activityConditionTypes = data.activityConditionTypes;
      this.addNew = data.addNew;
      this.showDeterminantBuilder = data.showDeterminantBuilder;
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public submit() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (!this.showDeterminantBuilder) {
        if (this.activityCondition.id === undefined) {
          this.createActivityCondition(this.serviceId, this.activityCondition);
        } else {
          this.saveActivityCondition(this.activityCondition);
        }
      } else {
        this.updateRegistrationActivityCondition(this.registrationActivityCondition);
      }
    }
  }

  public createActivityCondition(serviceId: string, activityCondition: ActivityCondition) {
    this.activityConditionControllerService.createActivityCondition(serviceId, activityCondition).subscribe(
      (data) => {
        this.addRegistrationActivityCondition(data);
      },
      (error) => {
        this.isLoading = false;
        this.showErrorMessage(error);
      },
    );
  }

  public addRegistrationActivityCondition(activityCondition) {
    if (this.registration !== undefined) {
      this.registrationActivityCondition = new RegistrationActivityCondition();
      this.registrationActivityCondition.activityConditionId = activityCondition.id;
      this.registrationActivityConditionControllerService.createActivityCondition(this.registration.id, this.registrationActivityCondition).subscribe(
        () => {
          this.responseSuccessful("Condition added to registration");
          this.activityConditionService.updateData();
          this.formSubmit.emit({ save: true });
          this.resetForm();
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
        () => this.isLoading = false,
      );
    }
  }

  public updateRegistrationActivityCondition(registrationActivityCondition) {
    this.registrationActivityConditionControllerService.saveRegistrationActivityCondition(registrationActivityCondition).subscribe(
      () => {
        this.responseSuccessful("Condition Registration updated!");
        this.activityConditionService.updateData();
        this.formSubmit.emit({ save: true });
        this.resetForm();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      () => this.isLoading = false,
    );
  }

  public saveActivityCondition(activityCondition: ActivityCondition) {
    this.activityConditionControllerService.saveActivityCondition(activityCondition).subscribe(
      () => {
        this.responseSuccessful("Condition saved!");
        this.activityConditionService.updateData();
        this.formSubmit.emit({ save: true });
        this.resetForm();
      },
      (error) => this.showErrorMessage(error),
      () => this.isLoading = false,
    );
  }

  public resetForm() {
    this.activityCondition = null;
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
    this.resetForm();
  }

  public closeDetLayer() {
    this.store.state.common.determinantSection.reset();
  }

  appendDeterminant = (det) => {
    let data = JSON.parse(this.registrationActivityCondition.jsonDeterminants);
    if (!Array.isArray(data)) {
      data = [];
    }
    if (data.length === 0) {
      data.push({
        type: 'OR',
        items: []
      });
    }
    let lastItem = data[data.length - 1];
    if (lastItem.items == null) {
      lastItem = {
        type: 'OR',
        items: []
      };
      data.push(lastItem);
    }
    lastItem.items.push({
      type: det.type || 'OR',
      determinantId: det.determinantId,
    });
    this.registrationActivityCondition.jsonDeterminants = JSON.stringify(data);
  };
}
